module.exports = __webpack_public_path__ + "377c0dbc231813aebc19fdbe187724ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/slideshow_07_mobile.jpg
// module id = 658
// module chunks = 0